module.exports = __webpack_public_path__ + "static/dc-orlando-6-80065a7d7e22482d795ec0d4a1e2ec75.jpg";